// extracted by mini-css-extract-plugin
export default {"cart-content":"CartPage_cart-content__3s-qY","content__items":"CartPage_content__items__T5v0H"};